export default "Comparez toutes les offres gaz et électricité pour votre entreprise. Courtier indépendant des fournisseurs d'énergie, audit gratuit de vos factures. Économisez en moyenne 18 %.";
